<template>
	<div class="xs-12 flex wrap xs-bottom p4">
		<div class="xs-12 flex wrap">
			<core-form-input
				componentName="j-base-input-text"
				name="name"
				label="name"
				v-model="name"
				:placeholder="node.name"
				v-validate="'required'"
				:validationErrors="errors"
			/>
		</div>

		<div class="flex xs-between mt6 xs-12">
			<j-button @click="$emit('hide')" type="bordered">
				{{ $t("cancel") }}
			</j-button>
			<j-button @click="updateName">{{ $t("update_name") }}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

export default {
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		node: {
			type: Object
		}
	},
	data: () => ({
		name: null
	}),
	methods: {
		async updateName() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.$emit("updateName", this.name)
		}
	}
}
</script>

<style>
</style>
